import * as React from 'react';
import { convertIcon } from '../components/Icon';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 20,
    height: 10,
    rx: 5,
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 5.99997,
    r: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 20,
    height: 10,
    rx: 5,
    fill: "#3BCE4A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 18,
    r: 3.5,
    fill: "white"
  }));
}
const IconComponent = convertIcon(SvgComponent, 'switch');
export default IconComponent;